import { render, staticRenderFns } from "./homeCollectionEvent.vue?vue&type=template&id=20d78da0"
import script from "./homeCollectionEvent.vue?vue&type=script&lang=js"
export * from "./homeCollectionEvent.vue?vue&type=script&lang=js"
import style0 from "./homeCollectionEvent.vue?vue&type=style&index=0&id=20d78da0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports